<script lang="ts" setup>

</script>
<template>
  <div class="main  auth-wrapper  d-flex align-center justify-center">
    <v-container class="mb-6">
      <v-row justify="center" align="center" no-gutters>

        <v-col xs="12" sm="8" md="6" class="align-center ">
          <v-card variant="elevated" class="card-form " rounded="xl">

            <router-view style="overflow-y: auto;max-height: 90vh" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style>
  .main {
    flex-direction: column;
    height: 100vh;
    background-image: url('/src/assets/images/auth/auth-bg.jpg');
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-size: cover;
  }

  .card-form {
    opacity: 0.9;
  }

  .pointer {
    cursor: pointer;
  }
</style>
